import *as _ from 'lodash'
import {DimensionBO} from "./DimensionBO";
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";

export class DimensionBOValidations{

    static ValidateEmptyFields(aBO: DimensionBO): Promise<void>{

        return new Promise<void>((resolve, error ) =>{
            //Validate Render Options
            if (_.isEmpty(aBO.WB_Dimension.cif.DIMENSION_ID) || _.isNull(aBO.WB_Dimension.cif.RENDER_OPTIONS)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Error,
                        code: 'dimensionIDEmpty',
                        title: "Dimension ID cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('dimensionIDEmpty')
            }

            if (_.isEmpty(aBO.WB_Dimension.cif.DIMENSION_NAME) || _.isNull(aBO.WB_Dimension.cif.DIMENSION_NAME)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Error,
                        code: 'dimensionNameEmpty',
                        title: "Dimension Name cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('dimensionNameEmpty')
            }

            if (_.isEmpty(aBO.WB_Dimension.cif.RENDER_OPTIONS) || _.isNull(aBO.WB_Dimension.cif.RENDER_OPTIONS)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Warning,
                        code: 'renderOptsEmpty',
                        title: "Render Options are empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('renderOptsEmpty')
            }

            //Validate Connection ID
            if (aBO.WB_Dimension.cif.WB_CONNECTION_ID == 0) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Warning,
                        code: 'connectionIdEmpty',
                        title: "Connection hasn't been selected",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('connectionIdEmpty')
            }

            //Validate Technical Name
            if (_.isEmpty(aBO.WB_Dimension.cif.TECHNICAL_NAME) || _.isNull(aBO.WB_Dimension.cif.TECHNICAL_NAME)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Warning,
                        code: 'technicalName',
                        title: "Technical name is empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('technicalName')
            }

            resolve()

        })

    }
}